import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d6e6585"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3d6e6585&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d6e6585')) {
      api.createRecord('3d6e6585', component.options)
    } else {
      api.reload('3d6e6585', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3d6e6585", function () {
      api.rerender('3d6e6585', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BusinessUnitForm/index.vue"
export default component.exports